export const getState = () => ({
  rechargeOperators: [],
  rechargeAmounts: [],
});

export default Object.assign(getState(), { getState: getState });
